import { Col } from 'components/Col';
import { CustomTextArea } from 'components/CustomTextArea';
import { HelpButton } from 'components/HelpButton';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.apoiadores!;
export default function Apoiadores() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'apoiadores',
        etapa: EtapaProjeto.aprendizagem,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  return (
    <Row>
      <Col>
        <CustomTextArea
          label={
            <>
              {language.label}
              <HelpButton style={{ margin: '0 8px' }} text={language.tooltip} />
            </>
          }
          placeholder={language.placeholder}
          name='apoiadores'
          value={state.projeto.apoiadores || ''}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                apoiadores: event.target.value,
              },
            });
          }}
          counter={true}
          maxSize={500}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          minRows={1}
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
